export class SchoolDetailsModel {
  schoolSk: string;
  schoolName: string;
  schoolDBN: string;
  schoolCSE: string;
  schoolAddress: string;
  schoolDistrict: string;
  schoolBorough: string;
  locationCode: string;
  buildingCode: string;
  streetAddress: string;
  schoolEmail: string;

  constructor(data: any) {
    this.schoolSk = data?.schoolSk;
    this.schoolName = data?.schoolName ?? data?.locationName;
    this.schoolDBN = data?.atsdbn ?? data?.schoolDBN;
    this.schoolCSE = data?.schoolCSE;
    this.schoolDistrict = data?.responsibleDistrict ?? data?.schoolDistrict;
    this.schoolBorough = data?.schoolBorough;
    this.locationCode = data?.locationCode;
    this.buildingCode = data?.buildingCode;
    this.schoolEmail = data?.schoolEmail;

    this.streetAddress = data?.address ?? '';

    this.schoolAddress = data?.schoolAddress ??
      `${data?.address ?? data?.streetAddress}, ${
        data?.city ?? ''
      }, ${data?.state ?? ''}, ${data?.zipCode ?? ''}`.trim();
  }
}